<template> </template>

<script>
export default {
  name: "Base",
  props: {
    width: {
      required: true
    },
    height: {
      required: true
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    cssClass: {
      type: String,
      default: ""
    }
  }
};
</script>
